import { format } from 'date-fns/format';

/**
 * Name for the zip a generation produces — `generated-documents-2026-07-27-1402.zip`.
 *
 * Readable at a glance in a Downloads folder, and date-first so a handful of them sort chronologically
 * rather than by whatever the browser felt like. Two runs in the same minute produce the same name; the
 * browser suffixes the duplicate, which is friendlier than a name nobody can read.
 *
 * Isomorphic on purpose. The server names the stored file, the client names the download, and the two
 * should not drift apart — a user who fetches the URL directly and a user who clicks the button ought to end
 * up with the same thing on disk.
 */
export function generationResultFileName(finishedAt: Date = new Date()): string {
  return `generated-documents-${format(finishedAt, 'yyyy-MM-dd-HHmm')}.zip`;
}
